export class Visible{
	init(){

		var elem = $('.features-list__item, .features-list__content');
		var self = this;

		self.checkIfVisible(elem);

		$(window).scroll(function() {
			self.checkIfVisible(elem);
		});
		this.delayShort($('.features-list--homepage-bands .features-list__item'));
		// this.delayShort($('.form--newsletter > *'));
	}
	checkIfVisible(elem){
		elem.each(function() {
			var $this = $(this),
				elemVisible = $this.visible(true, 'vertical');

			if(elemVisible){
				$this.addClass('on-screen', elemVisible);
				// if($this.hasClass('features-list__content')){
				// 	setTimeout(function() {
				// 		$this.addClass('flipped', elemVisible);
				// 	}, 1000);
				// }
				setTimeout(function() {
					$this.addClass('triggered');
				}, 500);
			}
		});
	}
	delay(elem){
		elem.each(function(index) {
			$(this).css('transition-delay', (300+(150*index) + 'ms'));
		});
	}
	delayShort(elem){
		elem.each(function(index) {
			$(this).css('transition-delay', ((50*index) + 'ms'));
		});
	}
	delayShortWithClick(elem){
		elem.each(function(index) {
			$(this).css('transition-delay', ((100*index) + 'ms'));
		});
	}
}